import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../../../assets/images/empty.png';
const _hoisted_1 = {
  class: "file-list-wrap"
};
const _hoisted_2 = {
  key: 0,
  class: "operation-bar"
};
const _hoisted_3 = {
  class: "table-wrap"
};
const _hoisted_4 = {
  key: 0,
  class: "nodata"
};
const _hoisted_5 = {
  class: "contract-list-btn"
};
const _hoisted_6 = {
  class: "el-pagination-wrap"
};
import { computed, ref, reactive, onMounted } from 'vue';
import { ElMessage } from "element-plus";
import { Search } from '@element-plus/icons-vue';
import dayjs from "dayjs";
import apis from "@/api";
import { useRouter } from "vue-router";
import Detail from "@/views/Advert/AdvertAccrue/Detail.vue";
import ContractSelect from "@/views/Advert/AdvertAccrue/components/ContractSelect.vue";
import AccrueLedger from "@/views/Advert/AdvertAccrue/components/AccrueLedger.vue";
import { USERINFO } from "@/store/mutation-types";
export default {
  __name: 'Index',
  setup(__props) {
    const router = useRouter();

    // 获取当前登录用户信息
    const getCurrentUserId = () => {
      try {
        const userInfo = JSON.parse(window.localStorage.getItem(USERINFO));
        return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) || '';
      } catch (e) {
        return '';
      }
    };
    const currentUserId = getCurrentUserId();
    const data = reactive({
      loading: false,
      currentDate: '',
      tableData: [],
      currentAuditList: []
    });
    const detailData = reactive({
      visible: false,
      type: 0,
      // 0查看 1审核 2 编辑
      title: '',
      month: '',
      // 计提年月
      monthId: '',
      // 计提月份ID
      accrueProofTemplateUrls: '' // 与添加计提任务中 accrueProofTemplateUrls 一致，英文逗号分隔
    });
    const accrueLedgerData = reactive({
      visible: false
    });
    const contractSelectData = reactive({
      visible: false,
      /** add：添加计提任务；append：继续添加合同 */
      selectType: 'add',
      /** 继续添加合同时带入行数据：month、endDate、accrueProofTemplateUrls（模板用列表行，不调接口） */
      appendPreset: null
    });
    const userRole = reactive({
      isAdmin: false,
      // 是否是管理员
      isSupplier: false,
      // 是否是供应商
      areaCode: '',
      // 管理员地区
      isProvince: false,
      // 省级管理员可以查看所有，但是只能编辑省级合同
      userId: '' // 用户id
    });
    const elLoading = ref(false);
    const headerStyle = reactive({
      background: '#FAFAFA'
    });
    const queryParam = reactive({
      month: '',
      status: '',
      areaCode: '',
      createBy: ''
    });
    const paginationObj = reactive({
      pageSize: 10,
      pageNo: 1,
      totalSize: 0
    });
    const loadData = () => {
      elLoading.value = true;
      apis.getAccrueList({
        pageNo: paginationObj.pageNo,
        pageSize: paginationObj.pageSize,
        ...queryParam
      }).then(res => {
        data.tableData = res.data.records;
        paginationObj.totalSize = res.data.total;
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleAddAccrue = () => {
      contractSelectData.selectType = 'add';
      contractSelectData.appendPreset = null;
      contractSelectData.visible = true;
    };

    /** 与审核相同：仅当前合同管理员（创建人）可操作 */
    const handleContinueAddContract = row => {
      contractSelectData.selectType = 'append';
      contractSelectData.appendPreset = {
        month: row.month,
        endDate: row.endDate || '',
        accrueProofTemplateUrls: row.accrueProofTemplateUrls || ''
      };
      contractSelectData.visible = true;
    };
    const handleAccrueLedger = () => {
      accrueLedgerData.visible = true;
    };
    const areaCodeName = [{
      code: '0000',
      name: '省'
    }, {
      code: '0691',
      name: '版纳'
    }, {
      code: '0692',
      name: '德宏'
    }, {
      code: '0870',
      name: '昭通'
    }, {
      code: '0871',
      name: '昆明'
    }, {
      code: '0872',
      name: '大理'
    }, {
      code: '0873',
      name: '红河'
    }, {
      code: '0874',
      name: '曲靖'
    }, {
      code: '0875',
      name: '保山'
    }, {
      code: '0876',
      name: '文山'
    }, {
      code: '0877',
      name: '玉溪'
    }, {
      code: '0878',
      name: '楚雄'
    }, {
      code: '0879',
      name: '普洱'
    }, {
      code: '0883',
      name: '临沧'
    }, {
      code: '0886',
      name: '怒江'
    }, {
      code: '0887',
      name: '迪庆'
    }, {
      code: '0888',
      name: '丽江'
    }];
    const getAreaName = code => {
      var _areaCodeName$find;
      return (_areaCodeName$find = areaCodeName.find(item => item.code === code)) === null || _areaCodeName$find === void 0 ? void 0 : _areaCodeName$find.name;
    };
    const handleView = (row, type) => {
      detailData.visible = true;
      detailData.type = type;
      const typeMap = {
        0: '查看',
        1: '审核',
        2: '编辑'
      };
      detailData.title = typeMap[type] || '查看';
      detailData.month = row.month;
      detailData.monthId = row.id || row.monthId || ''; // 从列表数据中获取 monthId
      detailData.accrueProofTemplateUrls = row.accrueProofTemplateUrls || '';
    };
    const handleSearch = () => {
      paginationObj.pageNo = 1;
      loadData();
    };
    const handleReset = () => {
      queryParam.month = '';
      queryParam.status = '';
      queryParam.areaCode = '';
      queryParam.createBy = '';
      handleSearch();
    };
    const handleSizeChange = val => {
      paginationObj.pageSize = val;
      paginationObj.pageNo = 1;
      loadData();
    };
    const handleCurrentChange = val => {
      paginationObj.pageNo = val;
      loadData();
    };

    // 获取角色信息
    const fetchRoleInfo = () => {
      apis.rolesOfLogin().then(res => {
        if (res !== null && res !== void 0 && res.success && Array.isArray(res.data)) {
          userRole.isAdmin = res.data.some(item => item.roleId && item.roleId.indexOf('contract_admin') >= 0);
          userRole.isSupplier = res.data.some(item => item.roleId && item.roleId.indexOf('vendor_') >= 0);
          const role = res.data.find(item => item.roleId && item.roleId.indexOf('contract_admin') >= 0);
          userRole.areaCode = role === null || role === void 0 ? void 0 : role.roleId.substring(role.roleId.length - 4);
          userRole.isProvince = userRole.areaCode && userRole.areaCode === '0000';
          const user = window.localStorage.getItem(USERINFO);
          userRole.userId = JSON.parse(user).userId;
        } else {
          ElMessage.error((res === null || res === void 0 ? void 0 : res.msg) || '获取角色失败');
          router.push('/home');
        }
      }).catch(() => {
        ElMessage.error('获取角色失败');
        router.push('/home');
      });
    };
    onMounted(() => {
      loadData();
      fetchRoleInfo();
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        inline: true,
        class: "filter-form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "计提年月"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: queryParam.month,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParam.month = $event),
            type: "month",
            "value-format": "YYYY-MM",
            format: "YYYY-MM",
            placeholder: "请选择年月",
            clearable: false,
            style: {
              "width": "180px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), userRole.isSupplier || userRole.isProvince ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "地区"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: queryParam.areaCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParam.areaCode = $event),
            placeholder: "",
            onChange: loadData,
            style: {
              "width": "150px"
            },
            "empty-values": [null, undefined, '']
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(areaCodeName, item => {
              return _createVNode(_component_el_option, {
                key: item.code,
                label: item.name,
                value: item.code
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), userRole.isSupplier || userRole.isProvince ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "合同管理员"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: queryParam.createBy,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParam.createBy = $event),
            clearable: "",
            style: {
              "width": "150px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            plain: "",
            onClick: handleSearch
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("查询", -1)]))]),
            _: 1
          }, 8, ["icon"]), _createVNode(_component_el_button, {
            onClick: handleReset,
            style: {
              "margin-left": "5px"
            }
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("重置", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), userRole.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: handleAddAccrue
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("添加计提任务", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleAccrueLedger
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("查看计提台账", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [data.tableData.length === 0 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[11] || (_cache[11] = [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        srcset: ""
      }, null, -1), _createElementVNode("p", {
        class: "txt"
      }, "暂 无 数 据", -1), _createElementVNode("p", {
        class: "txt2"
      }, "与您相关的计提月份列表将会在此处显示", -1)]))])), [[_directive_loading, data.loading]]) : _createCommentVNode("", true), _createElementVNode("div", null, [data.tableData.length > 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: data.tableData,
        style: {
          "width": "70%"
        },
        "header-cell-style": headerStyle,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "month",
          label: "年月"
        }), _createVNode(_component_el_table_column, {
          label: "地区"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(getAreaName(scope.row.areaCode)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "createByName",
          label: "合同管理员"
        }), _createVNode(_component_el_table_column, {
          prop: "contractCount",
          label: "合同数"
        }), _createVNode(_component_el_table_column, {
          prop: "auditedCount",
          label: "审核通过合同数"
        }), _createVNode(_component_el_table_column, {
          prop: "unAuditedCount",
          label: "待审核合同数"
        }), _createVNode(_component_el_table_column, {
          prop: "editCount",
          label: "编辑中合同数"
        }), _createVNode(_component_el_table_column, {
          label: "状态"
        }, {
          default: _withCtx(scope => [scope.row.contractCount === scope.row.auditedCount ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "success"
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("已完成", -1)]))]),
            _: 1
          })) : scope.row.unAuditedCount > 0 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "warning"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("待审核", -1)]))]),
            _: 1
          })) : scope.row.editCount > 0 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: "info"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("编辑中", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          prop: "endDate",
          label: "结束时间"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "140"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row, 0)
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("查看", -1)]))]),
            _: 1
          }, 8, ["onClick"]), userRole.isAdmin && scope.row.createBy === _unref(currentUserId) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row, 1)
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("审核", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), userRole.isAdmin && scope.row.createBy === _unref(currentUserId) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleContinueAddContract(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("继续添加合同", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), userRole.isSupplier ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row, 2)
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("编辑", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]]) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [5, 10, 20, 30, 40],
        "page-size": paginationObj.pageSize,
        total: paginationObj.totalSize,
        currentPage: paginationObj.pageNo,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => paginationObj.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(Detail, {
        visible: detailData.visible,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => detailData.visible = $event),
        title: detailData.title,
        type: detailData.type,
        month: detailData.month,
        monthId: detailData.monthId,
        "accrue-proof-template-urls": detailData.accrueProofTemplateUrls,
        userRole: userRole,
        onClose: loadData
      }, null, 8, ["visible", "title", "type", "month", "monthId", "accrue-proof-template-urls", "userRole"]), _createVNode(ContractSelect, {
        visible: contractSelectData.visible,
        "onUpdate:visible": _cache[5] || (_cache[5] = $event => contractSelectData.visible = $event),
        "select-type": contractSelectData.selectType,
        "append-preset": contractSelectData.appendPreset,
        onCommit: loadData,
        userRole: userRole
      }, null, 8, ["visible", "select-type", "append-preset", "userRole"]), _createVNode(AccrueLedger, {
        visible: accrueLedgerData.visible,
        "onUpdate:visible": _cache[6] || (_cache[6] = $event => accrueLedgerData.visible = $event),
        userRole: userRole
      }, null, 8, ["visible", "userRole"])]);
    };
  }
};